module.exports = __webpack_public_path__ + "23c72025c31e712d5a4d5b58eab2bd2d.MP3";